import { Component, OnInit, Input, Output, EventEmitter, Inject, Optional } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'dl-custom-confirmation-dialog',
  standalone: true,
  imports: [OneWebComponentsAngularModule],
  templateUrl: './custom-confirmation-dialog.component.html',
  styleUrls: ['./custom-confirmation-dialog.component.scss']
})
export class CustomConfirmationDialogComponent implements OnInit {
  @Input() public data: { title: string; message: string; confirmButtonText?: string };
  @Output() public closeDialog = new EventEmitter<any>();
  
  public dialogData: { title: string; message: string; confirmButtonText?: string };

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private matDialogData: any,
    @Optional() private dialogRef: MatDialogRef<CustomConfirmationDialogComponent>
  ) {
    if (this.matDialogData) {
      this.dialogData = this.matDialogData;
    }
  }

  ngOnInit(): void {
    if (this.data && !this.dialogData) {
      this.dialogData = this.data;
    }
  }

  onAccept() {
    if (this.dialogRef) {
      this.dialogRef.close(true);
    }
    this.closeDialog.emit(true);
  }

}
